import { combineReducers } from 'redux'
import { reducer as form  } from 'redux-form';
import client from './client'
import server from './server'

export const getContentsError = (state = false, action) => {
  switch (action.type) {
    case 'GET_CONTENTS_ERROR':
      return action.hasError;
    default:
      return state;
  }
}


export const reducers = combineReducers({
  client, server,
  getContentsError,
  form
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js